<template>
  <div>
    <van-sticky>
      <van-nav-bar
        title="订单详情"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
        right-text="修改"
        @click-right="onClickRight"

      />
    </van-sticky>





    <div style="width:100%;margin: 20px;">
      <van-button round type="primary" style="width:90%;margin: 0 auto;" @click="todownbaojia">下载报价单</van-button>
    </div>


    <van-cell-group inset>
      <van-cell title="订单ID" :value="orderdata.id" />
      <van-cell title="订单状态">
          <template #right-icon>
            <van-tag type="default" v-if="orderdata.status==0">未发布</van-tag>
            <van-tag type="warning" v-if="orderdata.status==1">等待调货</van-tag>
            <van-tag type="info" v-if="orderdata.status==2">等待发货</van-tag>
            <van-tag type="primary" v-if="orderdata.status==3">发货完成</van-tag>
            <van-tag type="danger" v-if="orderdata.status==4">待审核</van-tag>
          </template>
      </van-cell>
      <van-cell title="创建时间" :value="orderdata.create_datetime" />
      <van-cell title="发布时间" :value="orderdata.fabu_datetime" />
      <van-cell title="审核时间" :value="orderdata.shenpi_datetime" />
    </van-cell-group>

    <van-cell-group inset style="margin-top: 40px;">
      <van-cell title="客户名称" :value="orderdata.clientname" />
      <van-cell title="支付类型" :value="orderdata.pay_type" />
      <van-cell title="联系人" :value="orderdata.lxr" />
      <van-cell title="联系电话" :value="orderdata.phone" />
      <van-cell title="地址" :value="orderdata.address" />
    </van-cell-group>

    <van-cell-group inset style="margin-top: 40px;">
      <van-cell title="送货方式" :value="orderdata.send_type" />
      <van-cell title="订单总价" :value="orderdata.total_price" />
      <van-cell title="备注信息" :value="orderdata.beizhu" />
    </van-cell-group>
    <van-row type="flex" justify="space-between" style="margin-top: 20px;">
      <van-col :span="6" :offset="1">
        <van-button type="danger" v-if="orderdata.status==0" @click="delorder" round >删除订单</van-button>
      </van-col>
      <van-col :span="6">
        <van-button type="primary"  v-if="orderdata.status==0"  @click="isshenpi" round  v-loading="fabuloading">发布订单</van-button>
      </van-col>
      </van-row>

    <van-divider>订单产品</van-divider>

    <van-cell-group inset style="margin-top: 40px;" v-for="pd in orderdata.products" :key="pd.uuid">
      <van-cell title="产品名称" :value="pd.name" />
      <van-cell title="数量" :value="pd.count" />
      <van-cell title="单价" :value="pd.unitprice" />
      <van-cell title="小计" :value="pd.xiaoji" />
    </van-cell-group>

    <van-dialog v-model="spresonshow" title="存在低于价格线的产品" show-cancel-button @confirm="toconfirm">
      <van-field
        v-model="shenpireson"
        rows="5"
        autosize
        label="申请原因"
        type="textarea"
        placeholder="请输入留言"

      />
    </van-dialog>




  </div>
</template>

<script>
  import * as Api from './api.js'
import { Toast } from 'vant';
  export default {
    name: 'getmyorder',
    data () {
      return {
        value:'',
        orderdata:{},
        orderid:'',
        shenpireson:'',
        spresonshow:false,
		fabuloading:false



      }
    },
    created() {

      this.$store.dispatch('getlocaluserinfo').then(xx=>{
        this.orderid = this.$route.query.id
        this.getorderdetail()
      })

    },
    methods:{
      getorderdetail(){
        Api.orderdetail(this.orderid).then(res=>{
          console.log(res.data)
          this.orderdata = res.data
        })
      },
      onClickLeft(){
        this.$router.push({path:'/salerviews/myorder'})
      },
      delorder(){
        Api.delorder(this.orderdata.id).then(res=>{

          Toast({
            message: res.msg,
            icon: 'like-oo',
          });
          this.$router.push({path:'/'})
        })
      },
      isshenpi(){
		this.fabuloading = true
        this.orderdata.products.forEach(item=>{

          if (Number(item.unitprice)< Number(item.price_line)){
            this.spresonshow = true
			this.fabuloading = false
            return
          }
          this.fabuorder()
        })


      },
      toconfirm(){
        if(this.shenpireson!=''){
          this.fabuorder()
        }else{
          Toast({
            message:'申请原因不得为空！',
            icon: 'like-oo',
          });
		  
        }

      },
    fabuorder(){
        let data={
          id:this.orderdata.id,
          shenqingreson:this.shenpireson
        }
        Api.fabuorder(data).then(res=>{
			this.fabuloading = false
          Toast({
            message: res.msg,
            icon: 'like-oo',
          });
          this.getorderdetail()
        })
      },
      onClickRight(){
        if(this.orderdata.status == 0){
          this.$router.push({path:'/salerviews/orderedit',query:{id:this.orderdata.id}})
        }else{
          Toast({
            message: '该订单状态不允许修改，请退回订单后再尝试修改！',
            icon: 'like-oo',
          });
        }

      },
      todownbaojia(){
        let query={
          id:this.orderdata.id
        }
        Api.baojiadan(query).then(res=>{
          console.log(res)
          window.open(res.data.fileurl);


        })

      }

    }
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/salerviews/orderdetail/index.vue